import axios from 'axios';
import { SERVER } from '../hooks/config';

const axiosInstance = axios.create({
  baseURL: SERVER,
  withCredentials: true, // Important: envoie les cookies automatiquement
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour gérer les erreurs d'authentification
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide - le cookie sera supprimé côté serveur
      // Supprimer uniquement les données non-sensibles du localStorage
      localStorage.removeItem('adminEmail');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
